import Cookies from 'js-cookie'

import { getRootHostname } from '@surglogs/util'

import type { AuthTokenStoreEventData } from '@surglogs-app/types'

const COOKIE_NAME = 'shouldRedirectToLogin'
const COOKIE_PATH = '/'

const getDomain = () => {
  const domain = getRootHostname(window.location.hostname)

  return domain === 'localhost' ? 'localhost' : `.${domain}`
}

export const signInCookieSetter = (data: AuthTokenStoreEventData) => {
  if (data?.token) {
    /**
     * This cookie is stored in user's browser for easier access to the app afterwards,
     * Landing page based on this redirects user to login/signin if the user was authenticated before
     *
     */
    const expires = new Date()
    const customDuration = window.sessionStorage.getItem(
      'shouldRedirectToLoginExpireDuration',
    )
    const customDurationNumber = Number(customDuration)

    if (!isNaN(customDurationNumber) && customDurationNumber > 0) {
      /**
       * Custom expiration date for testing purposes, can be achieved by setting a custom
       * number of minutes to sessionStorage item with key shouldRedirectToLoginExpireDuration
       */
      expires.setTime(expires.getTime() + customDurationNumber * 60 * 1000)
    } else {
      /**
       * If there's no custom duration, sets expiration date to 90 days from this moment
       */
      expires.setTime(expires.getTime() + 90 * 24 * 60 * 60 * 1000)
    }

    Cookies.set(COOKIE_NAME, 'true', {
      domain: getDomain(),
      path: COOKIE_PATH,
      expires,
      // secure: true,
    })
  }
}

export const signInCookieClear = () => {
  Cookies.remove(COOKIE_NAME, {
    domain: getDomain(),
    path: COOKIE_PATH,
  })
}
